import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { usePaymentContext } from "../../contexts/PaymentContext/PaymentContext";
import { addDatadogPageView } from "../../services/datadog";
import { PATH } from "../path";

export const getPageNameFromPath = (pathname: string): string => {
	switch (pathname) {
		case PATH.SPLASH:
			return "splash";
		case PATH.PRODUCT_LIST:
			return "product_list";
		case PATH.CART:
			return "cart";
		case PATH.PAYMENT:
			return "payment";
		case PATH.ORDER_CONFIRMATION:
			return "order_confirmation";
		case PATH.INFO:
			return "info";
		case "/404":
			return "error_404";
		default:
			if (pathname.startsWith("/product/")) {
				return "product_detail";
			}

			return "unknown";
	}
};

export const usePageViewTracking = () => {
	const location = useLocation();
	const { state: paymentReference } = usePaymentContext((state) => state.paymentReference);

	useEffect(() => {
		const pageName = getPageNameFromPath(location.pathname);

		// Track page view with Datadog, include paymentReference if available
		addDatadogPageView(pageName, paymentReference || undefined, {
			pathname: location.pathname,
			search: location.search,
			timestamp: new Date().toISOString(),
		});
	}, [location.pathname, location.search, paymentReference]);
};
